import StoryblokClient from "storyblok-js-client";

const STORYBLOK_TOKEN = "6IZ0vOgqgQzxDA3NwB25Jwtt";
const isDev = process.env.NODE_ENV !== "production";

const api = new StoryblokClient({
  accessToken: STORYBLOK_TOKEN,
  cache: {
    clear: "auto",
    type: "memory",
  },
});

// basically the same functions defined in the Astro project
export async function getPostsOverview(params) {
  try {
    const tags = isDev
      ? "main-content-overview,DEV-main-content-overview"
      : "main-content-overview";

    const { data } = await api.get("cdn/stories", {
      content_type: "postsOverview",
      with_tag: tags,
      ...params,
    });

    const stories = Object.values(data.stories);
    return stories;
  } catch (error) {
    console.error("Error while fetching posts overview", error);
    return null;
  }
}

export async function getFolders(params) {
  try {
    const { data } = await api.get("cdn/links", {
      ...params,
    });

    const stories = Object.values(data.links);
    const folders = stories.filter((link) => link.is_folder === true);

    return folders;
  } catch (error) {
    console.error("Error while fetching stories", error);
    return [];
  }
}

export async function getPosts(params) {
  try {
    const { data } = await api.get("cdn/stories", {
      content_type: "post",
      ...params,
    });

    const stories = Object.values(data.stories);

    return stories;
  } catch (error) {
    console.error("Error while fetching posts", error);
    return [];
  }
}

export async function getHeaderData(sbVersion) {
  const version = sbVersion || "published";

  try {
    const rootPages = await getPostsOverview({ version });
    const folders = await getFolders({ version });

    const rootFolders = folders.filter((folder) => {
      return rootPages?.some((page) => page.parent_id === folder.id);
    });

    let postTags = ["show-in-header", "highlight-in-header"];
    if (isDev) {
      postTags = [...postTags, ...postTags.map((tag) => `DEV-${tag}`)];
    }

    const posts = await getPosts({
      version,
      with_tag: postTags.join(","),
    });

    const data = rootFolders
      .map((folder) => {
        return {
          overviewStory: rootPages.find((page) => page.parent_id === folder.id),
          parentFolder: folder,
          highlightedPosts: posts
            .filter(
              (post) =>
                post.full_slug.startsWith(folder.slug) &&
                post.tag_list.some((tag) => tag.endsWith("highlight-in-header"))
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .slice(0, 2),
          showInHeaderPosts: posts
            .filter(
              (post) =>
                post.full_slug.startsWith(folder.slug) &&
                post.tag_list.some((tag) => tag.endsWith("show-in-header"))
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .slice(0, 9),
        };
      })
      .sort((a, b) => a.parentFolder.name.localeCompare(b.parentFolder.name));

    return data;
  } catch (error) {
    console.error("Error while fetching posts overview", error);
    return null;
  }
}
